export default class ComparisonTable {
    constructor($element){
        this.$element = $element;
        this.$tabs = this.$element.find('.js-comparison-tabs');

        this.buildTabs();
        this.bindEvents();
    }

    buildTabs(){
        this.$element.find('.comparison-table__content').each((index, el) => {
            let heading = $(el).find('.heading-section').find('.heading--3').text().replace(/ .*/,'');
            //Add attribute to content element
            $(el).attr('data-id', heading);
            $(el).removeClass('comparison-table__content--active').eq(index).addClass('comparison-table__content--active');

            this.$tabs.append(
                eotwJSXFactory('button', {className: index === 0 ? 'comparison-table__tab comparison-table__tab--active js-comparison-table-btn large text-bold' : 'comparison-table__tab js-comparison-table-btn large text-bold', 'aria-label': "View " + heading + " package details", type: "button", 'data-id': heading }, [heading ])
            );
        });
    }

    bindEvents(){
        let $body = $('body');

        this.$element.on("click", ".js-open-comparison-modal", function () {
            $body.find(".modal--comparison-table").addClass("modal--active");
            return false;
        }).on('click', '.js-comparison-table-btn', function(){
            let id = $(this).attr("data-id");

            $body.find(".comparison-table__tab--active").removeClass("comparison-table__tab--active");
            $body.find(".comparison-table__content--active").removeClass("comparison-table__content--active");

            $(this).addClass("comparison-table__tab--active");
            $body.find(".comparison-table__content[data-id='" + id +"']").addClass("comparison-table__content--active");
            return false;
        });
    }
}
